/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  ClosingCommitmentBulkCreateDataRequest
} from '../../model/closingCommitmentBulkCreateDataRequest'
import type {
  ClosingCommitmentBulkCreateResponseData
} from '../../model/closingCommitmentBulkCreateResponseData'
import type {
  ClosingCreateDataRequest
} from '../../model/closingCreateDataRequest'
import type {
  ClosingData
} from '../../model/closingData'
import type {
  ClosingDataList
} from '../../model/closingDataList'
import type {
  ClosingListParams
} from '../../model/closingListParams'
import type {
  ClosingOrderOfOperationsAPIData
} from '../../model/closingOrderOfOperationsAPIData'
import type {
  ClosingSecurityOwnershipBulkCreateParams
} from '../../model/closingSecurityOwnershipBulkCreateParams'
import type {
  ClosingSecurityOwnershipCreateParams
} from '../../model/closingSecurityOwnershipCreateParams'
import type {
  ClosingStatsData
} from '../../model/closingStatsData'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  IdDataRequest
} from '../../model/idDataRequest'
import type {
  SecurityOwnershipClosingCreateDataRequest
} from '../../model/securityOwnershipClosingCreateDataRequest'
import type {
  SecurityOwnershipReadData
} from '../../model/securityOwnershipReadData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Returns a list of closings
 */
export const closingList = (
    fundFamilyId: string,
    params?: ClosingListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<ClosingDataList>(
      {url: `/fund-family/${fundFamilyId}/closing/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getClosingListQueryKey = (fundFamilyId: string,
    params?: ClosingListParams,) => {
    return [`/fund-family/${fundFamilyId}/closing/`, ...(params ? [params]: [])] as const;
    }

    
export const getClosingListQueryOptions = <TData = Awaited<ReturnType<typeof closingList>>, TError = unknown>(fundFamilyId: string,
    params?: ClosingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof closingList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClosingListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof closingList>>> = ({ signal }) => closingList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof closingList>>, TError, TData> & { queryKey: QueryKey }
}

export type ClosingListQueryResult = NonNullable<Awaited<ReturnType<typeof closingList>>>
export type ClosingListQueryError = unknown

export const useClosingList = <TData = Awaited<ReturnType<typeof closingList>>, TError = unknown>(
 fundFamilyId: string,
    params?: ClosingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof closingList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClosingListQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getClosingListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof closingList>>, TError = unknown>(fundFamilyId: string,
    params?: ClosingListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClosingListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof closingList>>> = ({ signal }) => closingList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingList>>, TError, TData> & { queryKey: QueryKey }
}

export type ClosingListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof closingList>>>
export type ClosingListSuspenseQueryError = unknown

export const useClosingListSuspense = <TData = Awaited<ReturnType<typeof closingList>>, TError = unknown>(
 fundFamilyId: string,
    params?: ClosingListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClosingListSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getClosingListLoader = (queryParamsOrFn?: (ClosingListParams | ((params: Params) => ClosingListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getClosingListQueryKey(fundFamilyId, queryParams),
              queryFn: () => closingList(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Creates a new closing
 */
export const closingCreate = (
    fundFamilyId: string,
    closingCreateDataRequest: ClosingCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<ClosingData>(
      {url: `/fund-family/${fundFamilyId}/closing/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: closingCreateDataRequest
    },
      options);
    }
  


export const getClosingCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingCreate>>, TError,{fundFamilyId: string;data: ClosingCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof closingCreate>>, TError,{fundFamilyId: string;data: ClosingCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closingCreate>>, {fundFamilyId: string;data: ClosingCreateDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  closingCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClosingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof closingCreate>>>
    export type ClosingCreateMutationBody = ClosingCreateDataRequest
    export type ClosingCreateMutationError = unknown

    export const useClosingCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingCreate>>, TError,{fundFamilyId: string;data: ClosingCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getClosingCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets a closing by id
 */
export const closingRetrieve = (
    fundFamilyId: string,
    closingId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<ClosingData>(
      {url: `/fund-family/${fundFamilyId}/closing/${closingId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getClosingRetrieveQueryKey = (fundFamilyId: string,
    closingId: string,) => {
    return [`/fund-family/${fundFamilyId}/closing/${closingId}/`] as const;
    }

    
export const getClosingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof closingRetrieve>>, TError = unknown>(fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof closingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClosingRetrieveQueryKey(fundFamilyId,closingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof closingRetrieve>>> = ({ signal }) => closingRetrieve(fundFamilyId,closingId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && closingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof closingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ClosingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof closingRetrieve>>>
export type ClosingRetrieveQueryError = unknown

export const useClosingRetrieve = <TData = Awaited<ReturnType<typeof closingRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof closingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClosingRetrieveQueryOptions(fundFamilyId,closingId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getClosingRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof closingRetrieve>>, TError = unknown>(fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClosingRetrieveQueryKey(fundFamilyId,closingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof closingRetrieve>>> = ({ signal }) => closingRetrieve(fundFamilyId,closingId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && closingId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ClosingRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof closingRetrieve>>>
export type ClosingRetrieveSuspenseQueryError = unknown

export const useClosingRetrieveSuspense = <TData = Awaited<ReturnType<typeof closingRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClosingRetrieveSuspenseQueryOptions(fundFamilyId,closingId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getClosingRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,closingId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,closingId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && closingId) {
            return appQueryClient.prefetchQuery({
              queryKey: getClosingRetrieveQueryKey(fundFamilyId,closingId),
              queryFn: () => closingRetrieve(fundFamilyId,closingId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Deletes a closing by id
 */
export const closingDelete = (
    fundFamilyId: string,
    closingId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/closing/${closingId}/`, method: 'DELETE'
    },
      options);
    }
  


export const getClosingDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingDelete>>, TError,{fundFamilyId: string;closingId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof closingDelete>>, TError,{fundFamilyId: string;closingId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closingDelete>>, {fundFamilyId: string;closingId: string}> = (props) => {
          const {fundFamilyId,closingId} = props ?? {};

          return  closingDelete(fundFamilyId,closingId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClosingDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof closingDelete>>>
    
    export type ClosingDeleteMutationError = unknown

    export const useClosingDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingDelete>>, TError,{fundFamilyId: string;closingId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getClosingDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Adds a security ownership to a closing
 */
export const closingCommitmentAdd = (
    fundFamilyId: string,
    closingId: string,
    idDataRequest: IdDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<ClosingData>(
      {url: `/fund-family/${fundFamilyId}/closing/${closingId}/add-security/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: idDataRequest
    },
      options);
    }
  


export const getClosingCommitmentAddMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingCommitmentAdd>>, TError,{fundFamilyId: string;closingId: string;data: IdDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof closingCommitmentAdd>>, TError,{fundFamilyId: string;closingId: string;data: IdDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closingCommitmentAdd>>, {fundFamilyId: string;closingId: string;data: IdDataRequest}> = (props) => {
          const {fundFamilyId,closingId,data} = props ?? {};

          return  closingCommitmentAdd(fundFamilyId,closingId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClosingCommitmentAddMutationResult = NonNullable<Awaited<ReturnType<typeof closingCommitmentAdd>>>
    export type ClosingCommitmentAddMutationBody = IdDataRequest
    export type ClosingCommitmentAddMutationError = unknown

    export const useClosingCommitmentAdd = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingCommitmentAdd>>, TError,{fundFamilyId: string;closingId: string;data: IdDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getClosingCommitmentAddMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Completes a closing
 */
export const closingToCompleteUpdate = (
    fundFamilyId: string,
    closingId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/closing/${closingId}/complete/`, method: 'PATCH'
    },
      options);
    }
  


export const getClosingToCompleteUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingToCompleteUpdate>>, TError,{fundFamilyId: string;closingId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof closingToCompleteUpdate>>, TError,{fundFamilyId: string;closingId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closingToCompleteUpdate>>, {fundFamilyId: string;closingId: string}> = (props) => {
          const {fundFamilyId,closingId} = props ?? {};

          return  closingToCompleteUpdate(fundFamilyId,closingId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClosingToCompleteUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof closingToCompleteUpdate>>>
    
    export type ClosingToCompleteUpdateMutationError = unknown

    export const useClosingToCompleteUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingToCompleteUpdate>>, TError,{fundFamilyId: string;closingId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getClosingToCompleteUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets the order of operations for a closing
 */
export const closingOrderOfOperationsRetrieve = (
    fundFamilyId: string,
    closingId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<ClosingOrderOfOperationsAPIData>(
      {url: `/fund-family/${fundFamilyId}/closing/${closingId}/order-of-operations/`, method: 'GET', signal
    },
      options);
    }
  

export const getClosingOrderOfOperationsRetrieveQueryKey = (fundFamilyId: string,
    closingId: string,) => {
    return [`/fund-family/${fundFamilyId}/closing/${closingId}/order-of-operations/`] as const;
    }

    
export const getClosingOrderOfOperationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>, TError = unknown>(fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClosingOrderOfOperationsRetrieveQueryKey(fundFamilyId,closingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>> = ({ signal }) => closingOrderOfOperationsRetrieve(fundFamilyId,closingId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && closingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ClosingOrderOfOperationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>>
export type ClosingOrderOfOperationsRetrieveQueryError = unknown

export const useClosingOrderOfOperationsRetrieve = <TData = Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClosingOrderOfOperationsRetrieveQueryOptions(fundFamilyId,closingId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getClosingOrderOfOperationsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>, TError = unknown>(fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClosingOrderOfOperationsRetrieveQueryKey(fundFamilyId,closingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>> = ({ signal }) => closingOrderOfOperationsRetrieve(fundFamilyId,closingId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && closingId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ClosingOrderOfOperationsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>>
export type ClosingOrderOfOperationsRetrieveSuspenseQueryError = unknown

export const useClosingOrderOfOperationsRetrieveSuspense = <TData = Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingOrderOfOperationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClosingOrderOfOperationsRetrieveSuspenseQueryOptions(fundFamilyId,closingId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getClosingOrderOfOperationsRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,closingId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,closingId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && closingId) {
            return appQueryClient.prefetchQuery({
              queryKey: getClosingOrderOfOperationsRetrieveQueryKey(fundFamilyId,closingId),
              queryFn: () => closingOrderOfOperationsRetrieve(fundFamilyId,closingId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Adds a security ownership to a closing
 */
export const closingCommitmentRemove = (
    fundFamilyId: string,
    closingId: string,
    idDataRequest: IdDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<ClosingData>(
      {url: `/fund-family/${fundFamilyId}/closing/${closingId}/remove-security/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: idDataRequest
    },
      options);
    }
  


export const getClosingCommitmentRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingCommitmentRemove>>, TError,{fundFamilyId: string;closingId: string;data: IdDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof closingCommitmentRemove>>, TError,{fundFamilyId: string;closingId: string;data: IdDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closingCommitmentRemove>>, {fundFamilyId: string;closingId: string;data: IdDataRequest}> = (props) => {
          const {fundFamilyId,closingId,data} = props ?? {};

          return  closingCommitmentRemove(fundFamilyId,closingId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClosingCommitmentRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof closingCommitmentRemove>>>
    export type ClosingCommitmentRemoveMutationBody = IdDataRequest
    export type ClosingCommitmentRemoveMutationError = unknown

    export const useClosingCommitmentRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingCommitmentRemove>>, TError,{fundFamilyId: string;closingId: string;data: IdDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getClosingCommitmentRemoveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Adds a list of security_ownerships to a closing
 */
export const closingSecurityOwnershipCreate = (
    fundFamilyId: string,
    closingId: string,
    securityOwnershipClosingCreateDataRequest: SecurityOwnershipClosingCreateDataRequest,
    params?: ClosingSecurityOwnershipCreateParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<SecurityOwnershipReadData>(
      {url: `/fund-family/${fundFamilyId}/closing/${closingId}/securities/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: securityOwnershipClosingCreateDataRequest,
        params
    },
      options);
    }
  


export const getClosingSecurityOwnershipCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingSecurityOwnershipCreate>>, TError,{fundFamilyId: string;closingId: string;data: SecurityOwnershipClosingCreateDataRequest;params?: ClosingSecurityOwnershipCreateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof closingSecurityOwnershipCreate>>, TError,{fundFamilyId: string;closingId: string;data: SecurityOwnershipClosingCreateDataRequest;params?: ClosingSecurityOwnershipCreateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closingSecurityOwnershipCreate>>, {fundFamilyId: string;closingId: string;data: SecurityOwnershipClosingCreateDataRequest;params?: ClosingSecurityOwnershipCreateParams}> = (props) => {
          const {fundFamilyId,closingId,data,params} = props ?? {};

          return  closingSecurityOwnershipCreate(fundFamilyId,closingId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClosingSecurityOwnershipCreateMutationResult = NonNullable<Awaited<ReturnType<typeof closingSecurityOwnershipCreate>>>
    export type ClosingSecurityOwnershipCreateMutationBody = SecurityOwnershipClosingCreateDataRequest
    export type ClosingSecurityOwnershipCreateMutationError = unknown

    export const useClosingSecurityOwnershipCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingSecurityOwnershipCreate>>, TError,{fundFamilyId: string;closingId: string;data: SecurityOwnershipClosingCreateDataRequest;params?: ClosingSecurityOwnershipCreateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getClosingSecurityOwnershipCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Creates a new closing
 */
export const closingSecurityOwnershipBulkCreate = (
    fundFamilyId: string,
    closingId: string,
    closingCommitmentBulkCreateDataRequest: ClosingCommitmentBulkCreateDataRequest,
    params?: ClosingSecurityOwnershipBulkCreateParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<ClosingCommitmentBulkCreateResponseData>(
      {url: `/fund-family/${fundFamilyId}/closing/${closingId}/securities/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: closingCommitmentBulkCreateDataRequest,
        params
    },
      options);
    }
  


export const getClosingSecurityOwnershipBulkCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingSecurityOwnershipBulkCreate>>, TError,{fundFamilyId: string;closingId: string;data: ClosingCommitmentBulkCreateDataRequest;params?: ClosingSecurityOwnershipBulkCreateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof closingSecurityOwnershipBulkCreate>>, TError,{fundFamilyId: string;closingId: string;data: ClosingCommitmentBulkCreateDataRequest;params?: ClosingSecurityOwnershipBulkCreateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closingSecurityOwnershipBulkCreate>>, {fundFamilyId: string;closingId: string;data: ClosingCommitmentBulkCreateDataRequest;params?: ClosingSecurityOwnershipBulkCreateParams}> = (props) => {
          const {fundFamilyId,closingId,data,params} = props ?? {};

          return  closingSecurityOwnershipBulkCreate(fundFamilyId,closingId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClosingSecurityOwnershipBulkCreateMutationResult = NonNullable<Awaited<ReturnType<typeof closingSecurityOwnershipBulkCreate>>>
    export type ClosingSecurityOwnershipBulkCreateMutationBody = ClosingCommitmentBulkCreateDataRequest
    export type ClosingSecurityOwnershipBulkCreateMutationError = unknown

    export const useClosingSecurityOwnershipBulkCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingSecurityOwnershipBulkCreate>>, TError,{fundFamilyId: string;closingId: string;data: ClosingCommitmentBulkCreateDataRequest;params?: ClosingSecurityOwnershipBulkCreateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getClosingSecurityOwnershipBulkCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Sends a closing for approval
 */
export const closingToApprovalUpdate = (
    fundFamilyId: string,
    closingId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/closing/${closingId}/send-for-approval/`, method: 'PATCH'
    },
      options);
    }
  


export const getClosingToApprovalUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingToApprovalUpdate>>, TError,{fundFamilyId: string;closingId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof closingToApprovalUpdate>>, TError,{fundFamilyId: string;closingId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closingToApprovalUpdate>>, {fundFamilyId: string;closingId: string}> = (props) => {
          const {fundFamilyId,closingId} = props ?? {};

          return  closingToApprovalUpdate(fundFamilyId,closingId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClosingToApprovalUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof closingToApprovalUpdate>>>
    
    export type ClosingToApprovalUpdateMutationError = unknown

    export const useClosingToApprovalUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closingToApprovalUpdate>>, TError,{fundFamilyId: string;closingId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getClosingToApprovalUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets stats for a closing
 */
export const closingStatsRetrieve = (
    fundFamilyId: string,
    closingId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<ClosingStatsData>(
      {url: `/fund-family/${fundFamilyId}/closing/${closingId}/stats/`, method: 'GET', signal
    },
      options);
    }
  

export const getClosingStatsRetrieveQueryKey = (fundFamilyId: string,
    closingId: string,) => {
    return [`/fund-family/${fundFamilyId}/closing/${closingId}/stats/`] as const;
    }

    
export const getClosingStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof closingStatsRetrieve>>, TError = unknown>(fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof closingStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClosingStatsRetrieveQueryKey(fundFamilyId,closingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof closingStatsRetrieve>>> = ({ signal }) => closingStatsRetrieve(fundFamilyId,closingId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && closingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof closingStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ClosingStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof closingStatsRetrieve>>>
export type ClosingStatsRetrieveQueryError = unknown

export const useClosingStatsRetrieve = <TData = Awaited<ReturnType<typeof closingStatsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof closingStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClosingStatsRetrieveQueryOptions(fundFamilyId,closingId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getClosingStatsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof closingStatsRetrieve>>, TError = unknown>(fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClosingStatsRetrieveQueryKey(fundFamilyId,closingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof closingStatsRetrieve>>> = ({ signal }) => closingStatsRetrieve(fundFamilyId,closingId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && closingId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ClosingStatsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof closingStatsRetrieve>>>
export type ClosingStatsRetrieveSuspenseQueryError = unknown

export const useClosingStatsRetrieveSuspense = <TData = Awaited<ReturnType<typeof closingStatsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClosingStatsRetrieveSuspenseQueryOptions(fundFamilyId,closingId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getClosingStatsRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,closingId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,closingId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && closingId) {
            return appQueryClient.prefetchQuery({
              queryKey: getClosingStatsRetrieveQueryKey(fundFamilyId,closingId),
              queryFn: () => closingStatsRetrieve(fundFamilyId,closingId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get updated stats for a closing
 */
export const closingStatsInterEntityRetrieve = (
    fundFamilyId: string,
    closingId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/closing/${closingId}/stats-v2/`, method: 'GET', signal
    },
      options);
    }
  

export const getClosingStatsInterEntityRetrieveQueryKey = (fundFamilyId: string,
    closingId: string,) => {
    return [`/fund-family/${fundFamilyId}/closing/${closingId}/stats-v2/`] as const;
    }

    
export const getClosingStatsInterEntityRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>, TError = unknown>(fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClosingStatsInterEntityRetrieveQueryKey(fundFamilyId,closingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>> = ({ signal }) => closingStatsInterEntityRetrieve(fundFamilyId,closingId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && closingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ClosingStatsInterEntityRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>>
export type ClosingStatsInterEntityRetrieveQueryError = unknown

export const useClosingStatsInterEntityRetrieve = <TData = Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClosingStatsInterEntityRetrieveQueryOptions(fundFamilyId,closingId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getClosingStatsInterEntityRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>, TError = unknown>(fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClosingStatsInterEntityRetrieveQueryKey(fundFamilyId,closingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>> = ({ signal }) => closingStatsInterEntityRetrieve(fundFamilyId,closingId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && closingId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ClosingStatsInterEntityRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>>
export type ClosingStatsInterEntityRetrieveSuspenseQueryError = unknown

export const useClosingStatsInterEntityRetrieveSuspense = <TData = Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    closingId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof closingStatsInterEntityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClosingStatsInterEntityRetrieveSuspenseQueryOptions(fundFamilyId,closingId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getClosingStatsInterEntityRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,closingId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,closingId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && closingId) {
            return appQueryClient.prefetchQuery({
              queryKey: getClosingStatsInterEntityRetrieveQueryKey(fundFamilyId,closingId),
              queryFn: () => closingStatsInterEntityRetrieve(fundFamilyId,closingId),
            }).then(() => null);
          }
          return null;
        });
      